// import { useCallback } from 'react'
import { ENV_RENDER_DESIGNER, REFER_TYPE } from './constant'
import { requestRefData } from './service'
import { awaitTo, referFilters, removeRepeat, getJsonObj } from './tools'
import referIndexDB from './cache'

// 设计器态
export function isDesigner (props) {
  return props.renderEnv === ENV_RENDER_DESIGNER
}

// 获取显示值
export function getShowValue (props) {
  if (props.multiple) return // 只展示单选
  const { value } = props;
  if (!value || value.length === 0) return ''
  return formatShowValueFromProps(props, props.value);
}

// 格式化显示值
export function formatShowValueFromProps (props, value) {
  if (!value || value.length === 0) {
    return ''
  }
  const { refReturn = [] } = props

  if (props.multiple && Array.isArray(value)) {
    const textField = typeof refReturn === 'string' ? [refReturn] : refReturn
    return [...value].map(e => refReturn.map(key => mulLanguage(e[textField])).join('-')).join(' ')
  }

  if (isCustomRefReturn(refReturn, props)) {
    return isCustomRefReturn(refReturn, props)
  }
  let showName = '' // 显示值
  if (typeof refReturn === 'string') {
    showName = mulLanguage(value?.[refReturn]) ?? ''
  } else {
    const nameArr = []
    refReturn.forEach(i => {
      if (i.startsWith('$')) {
        i = i.slice(1);
      }
      if (value?.[i] || value?.[i] === 0) {
        nameArr.push(mulLanguage(value[i]))
      } 
    });
    showName = nameArr.join('-')
  }
  return showName
}

// 用户自定义显示值
export function isCustomRefReturn(refReturn, props) {
  // const rootStore = props.pageStore.rootStore;
  if (typeof refReturn === 'string' && refReturn.startsWith('mobx://')) { // 如果是用户自定义显示,直接返回,不走内置解析
    return eval(refReturn.replace("mobx://", ''))
  } else {
    if (refReturn[0]?.startsWith('mobx://')) {
      return eval(refReturn[0].replace("mobx://", ''))
    }
  }
  return false
}

// 没有显示值时加载缓存
export async function loadShowValue (props, callback) {
  try {
    // 构建key值
    const { domainKey, serviceCode, showCEntityKeyFld, valueField, textField, value, alias } = props
    let cacheData = (await referIndexDB.getCache(`referData_${alias}`))?.value || {}

    if (props.multiple) { // 多选时不往store中塞值, 只展示, 
      const flag = value.find(e => !cacheData[e[valueField]])
      if (!flag) {
        callback(value.map(e => cacheData[e[valueField]]))
        return
      }
    } else {
      if (cacheData[value[valueField]]) {
        props.isFormatter ? callback([cacheData[value[valueField]]]) : setStore(props, [cacheData[value[valueField]]]);
        return
      }
    }
    const [meta] = await awaitTo(referIndexDB.getRefMeta(props, true), undefined, props)
    let data = await requestRefData(requestRefDataById(props, meta?.refEntity))
    data = data?.recordList || data || []
    if (!data.length) {
      data = handleValue(props, props.value).map(e => ({ ...e, [textField]: '' })) // 查不值默认空
    }
    const dataMap = data.reduce((pre, curr) => ({ ...pre, [curr[props.valueField]]: curr }), {})

    cacheData = (await referIndexDB.getCache(`referData_${alias}`))?.value || {}
    referIndexDB.setCache(`referData_${alias}`, {...cacheData, ...dataMap}, 120)

    if(props.isFormatter) return callback(data)

    if (data && data.length > 0) {
      if (props.multiple) { // 多选时不往store中塞值, 只展示, 
        callback(data)
      } else {
        setStore(props, data);
      }
    } else if (showCEntityKeyFld) { // 无显示值时显示主键值
      setNameReplaceId(props, valueField, callback)
    } else if (props.multiple) { // 多选时不往store中塞值, 只展示,
      callback(data) // removeRepeat --数组去重
    }
  } catch (error) {
    console.error(error);
    setNameReplaceId(props, props.valueField, callback)
  }
}

// 处理携带只带id的情况---解决--name 使用老数据
export function changeValue (newProps, oldProps) {
  try {
    const { multiple, valueField, refReturn } = newProps
    if (multiple) { // 多选
    } else {
      if (newProps.value?.[valueField] !== oldProps.value?.[valueField] && oldProps.value?.[valueField]) { // 不能删除
        if (newProps.value[valueField]) {
          const res = {...newProps.value}
          for (let i = 0; i < refReturn.length; i++) {
            if (newProps.value[refReturn[i]] === oldProps.value[refReturn[i]]) {
              delete res[refReturn[i]]
            }
          }
          return res
        } else {
          newProps.onChange({})
        }
      }
    }
    return newProps.value
  } catch (error) {
    console.error(error);
    return newProps.value
  }
}

// 多语
export function mulLanguage (text) {
  let _text = '';
  if (typeof text === 'object' && text !== null) {
    // _text = text[ctx.appCtx.localLanguage.tenantLangCode];
    // 工作内的参照如果当前语种没有值，取系统语种 
    _text = text[window.lang?.lang || 'zh_CN'] || text[window.cb?.context.global.getSysLocale() || 'zh_CN'];
  } else {
    try {
      _text = text.toString();
    } catch (error) {
      _text = '';
    }
  }
  return _text;
}

// 处理value值
export function handleValue (props, val) {
  let value = [];
  if (!props.multiple) { // 单选
    value = [val]
  } else {
    value = val;
  }
  return value;
}

export function getRefReturn(props) {
  let refReturn = props.refReturn;
  if (!Array.isArray(refReturn)) {
    refReturn = [refReturn]; // 确保refReturn是一个数组
  }
  refReturn.forEach((item, index) => {
    if (typeof item === 'string' && item.startsWith('$')) {
      refReturn[index] = item.slice(1); // 移除以"$"开头的字符
    }
  });
  return refReturn;
}

function getRefReturnByIndex (props, idx) {
  const s = getRefReturn(props);
  if (!s) {
    console.error(props.caption +  'no refReturn');
  }
  if (s?.length > idx) {  
    return s[idx];
  }
  return 'name'
}

// 值改变时判断是否需要更新显示值
export function onChangeValue (newValue, oldValue, props, referContext, callback) {
  if (!newValue) {
    // 多选参照为空时直接return;
    callback(newValue)
    return;
  }
  const cEntityKeyFld = props.valueField;
  if (isNeedQueryReferData(props, newValue, oldValue, cEntityKeyFld)) {
    loadShowValue(props, callback)
  }
}

function isNeedQueryReferData (props, newValue, oldValue, cEntityKeyFld) {
  if (props.multiple) {
    return true;
  }
  const newId = newValue?.[cEntityKeyFld] ?? '';
  const oldId = oldValue?.[cEntityKeyFld] ?? '';
  const key = getRefReturnByIndex(props, 0);
  const newName = newValue?.[key] ?? '';
  const oldName = oldValue?.[key] ?? '';
  if (newId !== oldId && newName !== oldName) {
    return false
  } else if (newId === oldId && newName === oldName) {
    return false
  } else {
    return true
  }
}

// 是否补充name
export function needInitLoadShowValue (props, value) {
  const { valueField, textField } = props;
  value = value ?? props.value
  if (isDesigner(props) || !value || value.length === 0) return;
  const key = getRefReturnByIndex(props, 0);
  const cEntityKeyFld = props.valueField;
  let id = ''; let name = '';
  if (props.multiple) { // 多选
    id = value[0]?.[cEntityKeyFld];
    name = value[0]?.[key];
    return id && !name
  } else {
    id = value[cEntityKeyFld];
    name = value[key];
    return id && !name && name !== '' && name !== 0
  }
}

function getTextField (props) {
  let textField = (typeof props.refReturn === 'object' ? props.refReturn[0] : props.refReturn) || ''; // 参照显示值 (有topName为树表, 树表时取meta中的显示字段)
  if (textField.startsWith('$')) {
    textField = textField.slice(1);
  }
  return textField
}

// 平铺props 数据
export function formatProps (props) {
  const flatField = {};
  flatField.domainKey = props.pageStore?.params?.domainKey;
  flatField.serviceCode = props.pageStore?.query?.serviceCode;
  flatField.billNo = props.pageStore?.params?.billNo || props.pageStore?.query?.billNo;
  flatField.busiObj = props.pageStore?.query?.busiObj;
  flatField.masterOrgValue = props.pageStore?.params?.orgId || undefined

  flatField.multiple = isMultiple(props)
  flatField.dataMultiple = props.multipleLines ? true : flatField.multiple

  flatField.bSmartSearch = props.bSmartSearch && props.subuiType !== 'drop'
  flatField.message = props.pageStore?.rootStore?.utils?.message || props.message
  flatField.startLoading = props.pageStore?.startLoading || props.startLoading
  flatField.endLoading = props.pageStore?.endLoading || props.endLoading

  flatField.valueField = props.valueField || getCEntityKeyFld(props) // 这个是根据用户设置定义的唯一值和参照模板唯一值不一样
  flatField.textField = getTextField(props);
  flatField.contentStyle = getJsonObj(props.contentStyle, {})

  flatField.conTextQuery = props.pageStore?.query || {}
  flatField.datasource = props.formStore?.get(`${props.storeField}_name`)?.fieldDesc?.field

  flatField.tableStore = props.rowStore?.tableStore || props.pageStore?.rootStore?.[props.store]

  return { ...flatField, ...props }
}

// 回写到store中
function setStore (props, data) {
  const value = handleValue(props, props.value);
  const newArr = data.map((item, index) => {
    return Object.assign({}, value[index], item)
  })
  props.onChange(newArr.pop())
}

function setNameReplaceId (props, valueField, callback) {
  if (props.showCEntityKeyFld) { // 无显示值时显示主键值
    const { refReturn } = props;
    let _refReturn = '';
    if (typeof refReturn === 'string') { // 单字段
      _refReturn = refReturn
    } else {
      _refReturn = refReturn[0];
    }
    if (!props.multiple) { // 单选
      props.onChange({
        ...props.value,
        [_refReturn]: props.value[valueField]
      })
    } else { // 多选
      const data = props.value.map(item => {
        item[_refReturn] = item[valueField]
        return item
      })
      callback(data)
    }
  }
}

// 是否多选
export function isMultiple (props) {
  const { selectType = 'single', value, multiple, canMultiple, multipleLines } = props
  if (multipleLines) return false
  if (multiple || canMultiple) return true
  if (selectType === 'single' && !Array.isArray(value)) { // 单选
    return false
  } else {
    return true
  }
}

// 获取参照主键字段
export function getCEntityKeyFld (props) {
  try {
    if (typeof props.refReturnArr !== 'string') {
      return 'id'
    }
    const refReturnArr = JSON.parse(props.refReturnArr); // 实体字段和参照字段映射关系
    let cEntityKeyFld = 'id' // 主键, 默认为id
    for (const i in refReturnArr) {
      if (refReturnArr[i].split(',').includes(props.storeField)) {
        if (i.startsWith('$')) {
          i = i.slice(1);
        }
        cEntityKeyFld = i;
      }
    }
    return cEntityKeyFld || 'id'
  } catch (error) {
    return 'id'
  }
}

// 从pageCache中取name
// function getDataFromPageStore (props) {
//   const value = handleValue(props, props.value)
//   let noName = false;
//   const data = value.map(item => {
//     item = props.pageStore.pageCache.cacheData.get(item[props.valueField]);
//     if (!item) noName = true;
//     return item;
//   })
//   if (noName) return false
//   else return data.length ? data : false
// }

// 通过id获取name值
export function requestRefDataById (props, meta = {}) {
  const { value, billNo, busiObj, domainKey, serviceCode, valueField, isMasterOrg, refCode, dataSourceAlias, conTextQuery } = props;
  const _value = handleValue(props, value)
  const conditions = _value.map(item => ({ field: valueField, op: "eq", value1: item[valueField] }))
  // 组装过滤条件
  const condition = {
    isExtend: true,
    simpleVOs: [{ logicOp: "or", conditions }]
  };
  const referType = REFER_TYPE.from(meta.cTpltype);
  const dataType = referType !== REFER_TYPE.TREE ? 'grid' : 'tree';

  const requestData = {
    refCode,
    condition: referType !== REFER_TYPE.TREE ? condition : undefined,
    treeCondition: referType === REFER_TYPE.TREE ? condition : undefined,
    dataType,
    billnum: billNo,
    isMasterOrg
  }
  const params = {
    ...conTextQuery,
    domainKey,
    busiObj,
    datasource: dataSourceAlias,
    serviceCode,
    refCode,
    feV: 6
  };
  return { requestData, params, props, noExtend: true }
}
